/* eslint-disable prettier/prettier */
import React, { createContext, useState } from 'react';
export const StoreMgmtContext = createContext<any>('');
export function StoreMgmtContextProvider(props: any) {
    const [createTaskModal, setcreateTaskModal] = useState(false)
    const [TaskandGoals, setTaskandGoals] = useState('');
    const [goals, setGoals] = useState('')
    const [priorityFieldVisitPhase2, setPriorityFieldVisitPhase2] = useState('0')
    const [updateRecieptKey, setUpdateRecieptKey] = useState(null)
    const [emailRestrictedVerificationLevels, setEmailRestrictedVerificationLevels] = useState('');
    const [MXStoreIdentifier, setMXStoreIdentifier] = useState('0');
    const [enablecountrycode, setEnablecountrycode] = useState(0);
    const [enableLivelinessCheck, setEnableLivelinessCheck] = useState("");
    const [enableManualSelfieUpload, setEnableManualSelfieUpload] = useState("");
    const [mxStoreIdentifier, setMxStoreIdentifier] = useState("0");


    return (
        <div>
            <StoreMgmtContext.Provider
                value={{
                    createTaskModal,
                    setcreateTaskModal,
                    TaskandGoals,
                    setTaskandGoals,
                    updateRecieptKey,
                    setUpdateRecieptKey,
                    priorityFieldVisitPhase2,
                    setPriorityFieldVisitPhase2,
                    goals,
                    setGoals,
                    setEmailRestrictedVerificationLevels,
                    emailRestrictedVerificationLevels,
                    MXStoreIdentifier, setMXStoreIdentifier,
                    enablecountrycode, setEnablecountrycode,
                    enableLivelinessCheck, setEnableLivelinessCheck,
                    enableManualSelfieUpload, setEnableManualSelfieUpload,
                    mxStoreIdentifier, setMxStoreIdentifier,
                }}
            >
                {props.children}
            </StoreMgmtContext.Provider>
        </div>
    );
}
